// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"76":"fxa-common-password-list","349":"fxaCryptoDeriver","628":"fxaPairingChannel","639":"webcrypto-liner","918":"asmcrypto.js","970":"fast-text-encoding"}[chunkId] || chunkId) + ".bundle.js";
};